function HomeIntro(): JSX.Element {
  return (
    <div className="mx-auto mb-12 max-w-3xl px-4 text-center">
      <h2 className="mb-4 text-3xl font-semibold text-slate-700">
        Why you'll love <span className="logo-font font-bold">Xhalin</span>
      </h2>
      <p className="text-center text-slate-500">
        Every feature is designed to help you breathe deeper, focus better, and
        grow calmer.
      </p>
    </div>
  );
}

export default HomeIntro;
